export default {
  "item1":"Ebike Design Department",
  "item2":"Ebike Assembly Line",
  "item3":"Ebike Assembly Line",
  "item4":"Bike Wheel Assembly Area",
  "item5":"Ebike Materials Preparation Area",
  "item6":"Ebike Assembling",
  "item7":"Semi-finished Ebikes",
  "item8":"Ebike Testing Area",
  "item9":"Ebike Packing Area",
  "item10":"Ebike Packing Area",
  "item11":"Warehouse",
  "item12":"Ebike Bulk Shipment",
  "item13":"Salt Spray Test Room",
  "item14":"Ebike Battery Assembly Line",
  "item15":"Battery Aging Test",
  "item16":"Battery Aging Test"
};
